import { Api } from '@axiom/ui';
import type {
  MLRecommendation,
  Opportunity,
  RequestMLRecommendations,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class MlRecommendationsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async createRecommendations(body: Partial<RequestMLRecommendations>) {
    return super.write<{ data: number }>({
      method: 'POST',
      endpoint: `/opportunities/${body.opportunityId}/recommendations`,
      body,
    });
  }

  readRecommendations(opportunityId: Opportunity['id']) {
    return super.read<{ data: MLRecommendation[] }>({
      method: 'GET',
      endpoint: `/opportunities/${opportunityId}/recommendations`,
    });
  }

  async updateRecommendation({
    opportunityId,
    candidateId,
    ...body
  }: Partial<MLRecommendation>) {
    return super.write<MLRecommendation>({
      endpoint: `/opportunities/${opportunityId}/recommendations/candidates/${candidateId}`,
      method: 'PATCH',
      body,
    });
  }

  async refreshRecommendations(opportunityId: Opportunity['id']) {
    return super.invalidate(`/opportunities/${opportunityId}/recommendations`);
  }
}

export const MlRecommendationsApi = new MlRecommendationsApiClass();
